import { InvoicesSendingTypeValues } from "@/constants/payments";
import { Contract, Process, Segment } from "@/types/contract";
import { GeneralContactsFormValues } from "./form";
import { isTCRProcessDeath, isTCRProcessDismantling } from "@/utils/contract";
import { isCompany, isHousehold } from "@/utils/customer";
import { equals } from "remeda";
import { TFunction } from "i18next";

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getEBill = (contract: Contract, values: GeneralContactsFormValues, isContractRequest: boolean) => {
  const emailEbillDefault = contract.customer.contact.emailEbill?.trim() ?? "";
  const isEbillEditable = !!contract.customer.ebillEdit;
  const isTCRDeath = isTCRProcessDeath(contract);
  const trimmedEmailValue = values.email.trim();

  if (isEbillEditable === false) {
    return emailEbillDefault;
  }
  if (contract.process === Process.MOBILITY_SERVICES || contract.process === Process.VRB) {
    return trimmedEmailValue;
  }
  if (isContractRequest && contract.process === Process.PS && contract.processReason === "01") {
    if (values.eBillCheckbox) {
      return trimmedEmailValue;
    } else {
      return values.emailEbill.trim();
    }
  }
  if (
    contract.process === Process.RECONTRACTING ||
    isTCRDeath ||
    (contract.process === Process.PS && isContractRequest && contract.processReason === "02")
  ) {
    if (values.eBillCheckbox) {
      return trimmedEmailValue;
    } else {
      return emailEbillDefault;
    }
  } else {
    if (emailEbillDefault || contract.selfService === false) {
      return emailEbillDefault;
    } else {
      return trimmedEmailValue;
    }
  }
};

export const setSendingInvoiceType = (contract: Contract, values: GeneralContactsFormValues) => {
  if (
    ["S1", "S2", "S3", "S4", "R1", "R2", "R3", "MS", "VRB", "ZDP"].includes(contract.process) &&
    contract.selfService === true
  ) {
    return InvoicesSendingTypeValues.Mail;
  }
  return values.eBillCheckbox ? InvoicesSendingTypeValues.Mail : contract.paymentInfo!.sendingInvoicesType;
};

export const showB2BTooltip = (contract: Contract) => {
  const { process, customer, segment } = contract;

  return (
    (process === Process.RECONTRACTING ||
      process === Process.ZDP ||
      process === Process.PS ||
      process === Process.NEW_POINT ||
      process === Process.TCR) &&
    segment === Segment.B2B &&
    isCompany(customer)
  );
};

export const showMobilePhone = (contract: Contract) => !(contract.process === Process.PS && contract.processReason === "02");

export const showEbillCheckbox = (contract: Contract, values: GeneralContactsFormValues, isContractRequest: boolean) => {
  const isZSPProcess = contract.process === Process.RECONTRACTING;
  const emailsAreEqual = equals(contract.customer.contact.email, values.email);
  const isPSRequestProcess = contract.process === Process.PS && isContractRequest;
  const isTCRDismantlingB2B = isTCRProcessDismantling(contract) && !isHousehold(contract.customer);

  if (isPSRequestProcess && contract.customer.ebillEdit === true) {
    return true;
  }
  return (
    (isZSPProcess || isTCRProcessDeath(contract) || isPSRequestProcess || isTCRDismantlingB2B) &&
    (!emailsAreEqual || contract.customer.contact.emailEbill === null) &&
    contract.customer.ebillEdit === true
  );
};

export const showEbillInput = (contract: Contract, values: GeneralContactsFormValues, isContractRequest: boolean) => {
  const isPSRequestProcess = contract.process === Process.PS && isContractRequest;

  return (
    isPSRequestProcess &&
    contract.processReason === "01" &&
    contract.paymentInfo?.sendingInvoicesType === InvoicesSendingTypeValues.Mail &&
    values.eBillCheckbox === false
  );
};

export const getEbillCheckboxLabel = (contract: Contract, isContractRequest: boolean, t: TFunction<"customer">) => {
  const isPSProcess = contract.process === Process.PS;
  if (
    (isPSProcess && isContractRequest) ||
    isTCRProcessDeath(contract) ||
    (isTCRProcessDismantling(contract) && !isHousehold(contract.customer))
  ) {
    return t("eBillEmailRequest");
  } else {
    return t("eBillEmail");
  }
};
